export const markerTypes = [
  { label: 'Pin', value: 'pin' },
  { label: 'Dot', value: 'dot' },
  { label: 'Image', value: 'image' }
]

export const viewTypes = [
  { label: 'Calendar View', value: 'calendarView' },
  { label: 'Map View', value: 'mapView' },
  { label: 'List View', value: 'listView' }
]

export function setViewTypeList(map = false, calendar = false) {
  return [
    { label: 'List View', value: 'listView' },
    ...(map ? [{ label: 'Map View', value: 'mapView' }] : []),
    ...(calendar ? [{ label: 'Calendar View', value: 'calendarView' }] : [])
  ]
}
